module.exports = __webpack_public_path__ + "static/media/homeitem8.a75b531d.png";